import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SortType } from 'shared-lib';
import { ChecklistItem } from '../../models/checklist-item.model'; // Import ChecklistItem

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
  standalone: false
})
export class FilterComponent implements OnInit {

  @Output() sortChanged = new EventEmitter<SortType>();
  @Output() filterWindow = new EventEmitter<boolean>();
  @Output() dynamicFilterWindow = new EventEmitter<boolean>();
  @Output() addFilterCard = new EventEmitter<ChecklistItem>(); // Change to ChecklistItem
  @Output() clearSearch = new EventEmitter<void>();

  mapSortBy: Record<number, string> = {
    [SortType.NEWEST]: 'Newest',
    [SortType.ID_ASC]: 'ID',
    [SortType.ID_DESC]: 'ID',
    [SortType.SLRN_ASC]: 'SLRN',
    [SortType.SLRN_DESC]: 'SLRN',
  };

  dropdownOpened: boolean = false;
  sortByValue: SortType = SortType.NEWEST; 
  sortByName: string = this.mapSortBy[SortType.NEWEST];
  sortByOptions = SortType;
  searchText: string = '';

  ngOnInit(): void {}

  onSearchChange(text: string) {
    this.searchText = text;
  }

  onAddFilter() {
    this.filterWindow.emit(true);
  }

  onAddDynamicFilter() {
    this.dynamicFilterWindow.emit(true);
  }
  
  toggleDropdown() {
    this.dropdownOpened = !this.dropdownOpened;
  }

  selectSortByOption(option: SortType) {
    this.sortByValue = option;
    this.sortByName = this.mapSortBy[option];
    this.sortChanged.emit(option);
    this.dropdownOpened = false;
  }

  addSlrnFilter() {
    if (this.searchText.trim()) {
      const checklistItem = new ChecklistItem(
        'Search',
        this.searchText.trim(),
        'COMMON.SEARCH',
        this.searchText.trim()
      );
      this.addFilterCard.emit(checklistItem);
      this.searchText = '';
    }
  }
}